document.addEventListener('DOMContentLoaded', () => {
    const productTab = {
        tab: '.proven-results__tab',
        activeClass: 'proven-results__tab--active',
        productTab: {
            panel: '.proven-results__panel',
            panelV2: '.proven-results__content-v2--panel',
            mediaPanel: '.proven-results__media-panels--inner'
        },
        arrows: {
            arrow: '.proven-results__tabs--arrow',
            left: '.proven-results__tabs--arrow-left',
            right: '.proven-results__tabs--arrow-right'
        },
        mobileArrow: {
            left: '.proven-results__content-v2--arrow-left',
            right: '.proven-results__content-v2--arrow-right'
        }
    }

    const section = document.querySelector('.proven-results__section');
    const productTabs = section.querySelectorAll(productTab.tab);
    const resultsPanels = section.querySelectorAll(productTab.productTab.panel);
    const resultsPanelsV2 = section.querySelectorAll(productTab.productTab.panelV2);
    const featuredMediaPanels = section.querySelectorAll(productTab.productTab.mediaPanel);
    const mainSlider = section.querySelector('.js-half-slider-main');
    const thumbSlider = section.querySelector('.js-half-slider-thumbs');

    const thumbSliderSettings = {
        spaceBetween: 15,
        slidesPerView: 'auto',
        loop:false,
        watchSlidesProgress: true,
        centerInsufficientSlides: false,
        grabCursor: true,
        draggable: false,
        freeMode: false
    }

    let thumbSwiper = new Swiper(thumbSlider, thumbSliderSettings);
    const mainSwiper = new Swiper(mainSlider,{
        draggable: false,
        loop:false,
        slidesPerView: 'auto',
        a11y: true,
        spaceBetween: 20,
        navigation: {
            nextEl: `.js-half-slider-main .swiper-button-next`,
            prevEl: `.js-half-slider-main .swiper-button-prev`,
        },
        pagination: {
            el: `.js-half-slider-main .swiper-pagination`,
            type: 'bullets',
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        grabCursor: true,
        thumbs: {
            swiper: new Swiper(thumbSlider, thumbSliderSettings)
        },
        slidesPerView: 'auto',
        breakpoints: {
            320: {
                spaceBetween: 0,
                initialSlide: 0,
            },
            768: {
                spaceBetween: 30
            },
            1200: {
                spaceBetween: 80
            },
            1600: {
                spaceBetween: 88
            }
        }
    });

    productTabs.forEach(function (tab) {
        tab?.addEventListener("click", function (e) {
            productTabs.forEach(t => t.classList.remove(productTab.activeClass));
            e.target.classList.add(productTab.activeClass);
            const currentTab = e.target.dataset.tab;

            const updateSlidesVisibility = (selector, tab) => {
                const slides = section.querySelectorAll(selector);
                slides.forEach(slide => {
                    slide.style.display = slide.dataset.tab === tab ? '' : 'none';
                });
            };
            updateSlidesVisibility('.js-proven-results-slide', currentTab);
            updateSlidesVisibility('.js-proven-results-thumb-slide', currentTab);
    
            // Delayed reinitialization
            setTimeout(() => {
                thumbSwiper.destroy(true, true);
                thumbSwiper = new Swiper(thumbSlider, thumbSliderSettings);
                mainSwiper.thumbs.swiper = thumbSwiper;
                thumbSwiper.update(); // Ensure the thumb swiper updates its internal state
                mainSwiper.update();
                console.log('Swipers updated with new settings');
            }, 100); // Adjust delay as necessary

            resultsPanels.forEach(function (panel) {
                if (e.target.dataset.tab === panel.dataset.panel) {
                    if (panel.classList.contains('hidden')) panel.classList.remove('hidden');
                } else {
                    panel.classList.add('hidden');
                }
            });
            
            if(resultsPanelsV2) {
                resultsPanelsV2.forEach(function (panel) {
                    if (e.target.dataset.tab === panel.dataset.panel) {
                        if (panel.classList.contains('hidden')) panel.classList.remove('hidden');
                    } else {
                        panel.classList.add('hidden');
                    }
                });
            }

            if(featuredMediaPanels) {
                featuredMediaPanels.forEach(function (mediaPanel) {
                    if (e.target.dataset.tab === mediaPanel.dataset.panel) {
                        if (mediaPanel.classList.contains('hidden')) mediaPanel.classList.remove('hidden');
                    } else {
                        mediaPanel.classList.add('hidden');
                    }
                });
            }
        });
    });

    var resultsMobileSlider = document.querySelector('[data-proven-results-slider]');
    new Swiper(resultsMobileSlider, {
        loop: false,
        autoHeight: true,
        draggable: false,
        slidesPerView: 1,
        a11y: true,
        spaceBetween: 0,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        grabCursor: true
    });

    var tabsLength = Number(productTabs.length);
    var tabArrowRight = document.querySelector(productTab.arrows.right);
    var tabArrowLeft = document.querySelector(productTab.arrows.left);
    var mobileLeftArrow = document.querySelector(productTab.mobileArrow.left);
    var mobileRightArrow = document.querySelector(productTab.mobileArrow.right);

    tabArrowRight?.addEventListener("click", function (a) {
        let __activeTabIndex = '';
        productTabs.forEach(function (tab) {
            if(tab.classList.contains(productTab.activeClass)) __activeTabIndex = Number(tab.dataset.index);
        });
        if(__activeTabIndex < tabsLength) {
            productTabs[__activeTabIndex].click();
        } else if(__activeTabIndex === tabsLength) {
            productTabs[Number(tabsLength - __activeTabIndex)].click();
        }
    });

    tabArrowLeft?.addEventListener("click", function (a) {
        let __activeTabIndex = '';
        productTabs.forEach(function (tab) {
            if(tab.classList.contains(productTab.activeClass)) __activeTabIndex = Number(tab.dataset.index);
        });
        if(__activeTabIndex == 1) {
            productTabs[Number(tabsLength - 1)].click();
        } else if(__activeTabIndex == tabsLength) {
            productTabs[Number(tabsLength - 2)].click();
        } else if(__activeTabIndex < tabsLength) {
            productTabs[Number(__activeTabIndex - 2)].click();
        }
    });

    mobileRightArrow?.addEventListener("click", function (a) {
        tabArrowRight.click();
    });

    mobileLeftArrow?.addEventListener("click", function (a) {
        tabArrowLeft.click();
    });

    if(section) {
        const addToCartButton = section.querySelectorAll("[panel-add-to-cart]");
        addToCartButton?.forEach(function (button) {
            button?.addEventListener("click", function (e) {
                if(e.target.dataset.productId) {
                    let item = {
                        id: e.target.dataset.productId,
                        quantity: "1"
                    }
                    VueMinicart.config.globalProperties.$store.dispatch('addItem', item);
                }
            });
        });
    }
});